<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="6">
                Accounts
              </b-col>
              <b-col cols="6" class="text-right">
                <b-btn size="sm" variant="success" @click="add"><i class="icon-plus mr-1"></i>Add</b-btn>
              </b-col>
            </b-row>
          </template>
          <b-table class="mb-2 table-outline" responsive="sm" head-variant="light" :hover="true" :items="accounts" :fields="fields" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
            <template v-slot:cell(type)="data">
              <account-type :type="data.value"></account-type>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="getRowCount(accounts)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <add-account-modal @add="addAccount" />
  </div>
</template>

<script>
import AccountType from '@/components/badges/AccountType'
import AddAccountModal from './partials/AddAccount'

export default {
  name: 'accounts',
  components: {
    AccountType,
    AddAccountModal
  },
  data () {
    return {
      hover: false,
      striped: true,
      bordered: false,
      small: false,
      fixed: false,
      accounts: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name' },
        { key: 'prefix' },
        { key: 'type', class: 'text-right' }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }
  },
  methods: {
    add () {
      this.$bus.$emit('modal:addAccount')
    },
    addAccount (account) {
      this.$router.push({path: `/system/accounts/${account.id}`})
    },
    getRowCount (items) {
      return items.length
    },
    getAccounts () {
      this.$axios.get(`/v1/accounts`).then((response) => {
        this.accounts = response.data
      }).catch((err) => console.log(err))
    },
    rowClicked (item) {
      this.$router.push({path: `/system/accounts/${item.id}`})
    }
  },
  created () {
    this.getAccounts()
  }
}
</script>
